import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const RIGHT_ROW_WIDTHS = ['w-1/3', 'w-1/2', 'w-2/3', 'w-1/4', 'w-1/2', 'w-3/4', 'w-1/3', 'w-1/2', 'w-2/5', 'w-1/2', 'w-1/3', 'w-3/5']

const ScheduleDetailSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col h-[calc(100vh-135px)] min-h-0">
      <div className="flex items-center gap-3">
        <Skeleton className="h-8 w-8 rounded-md" />
        <Skeleton className="h-7 w-64" />
        <Skeleton className="h-5 w-16 rounded-full" />
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
      <div className="py-2 flex items-center gap-2">
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-[140px]" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-[200px]" />
        <Skeleton className="ml-auto h-8 w-24" />
      </div>
      <div className="flex-1 min-h-0 flex gap-px">
        <div className="w-[560px] space-y-1">
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} className="h-8 w-full" />
          ))}
        </div>
        <div className="flex-1 space-y-1">
          {RIGHT_ROW_WIDTHS.map((w, i) => (
            <Skeleton key={i} className={`h-8 ${w}`} />
          ))}
        </div>
      </div>
    </div>
  )
}
export default ScheduleDetailSkeleton
